$(document).ready(function () {
  $(".line_botn_vr2 #close-btn").on("click", function () {
    $("#notification").slideUp("slow", function () {
      $("#toggle-btn").fadeIn();
    });
  });

  $(".line_botn_vr2 #toggle-btn").on("click", function () {
    $("#toggle-btn").fadeOut(function () {
      $("#notification").slideDown("slow");
    });
  });

  // 初期表示で通知をスライドダウンし、ボタンを非表示にする
  $("#notification").show();
  $("#toggle-btn").hide();
});
